import { React } from "react";
import { Link } from "react-router-dom";
// PAGES
import SidebarAccount from "./SidebarAccount";
// ICONS
import { StatusOnlineIcon } from "@heroicons/react/solid";
// RESOURCES
import sidebarBg from "../../assets/images/sidebar-bg.png";
import px1Device from "../../assets/images/px1-icon.png";

const SidebarDesktop = (props) => {
  return (
    <div className="bg-white hidden md:flex md:w-80 md:flex-col md:fixed h-navbar">
      {/* SIDEBAR */}
      <div
        className="flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-cover"
        style={{ backgroundImage: `url(${sidebarBg})` }}
      >
        <div className="flex-1 flex flex-col pt-5 px-4 pb-4 overflow-y-auto">
          <div className="text-md text-left   text-vide-purple hover:text-vide-purple">
            {props.titleSidebar}
          </div>

          <div>
            <div className="flow-root mt-6">
              <ul role="list" className="-my-5 divide-y divide-gray-200">
                {props.devices.map((device) => (
                  <li key={`desktop-desktop-${device.ID}`}>
                    <Link
                      to={`/dash/devices/${device.ID}/collection`}
                      className="mt-2 col-span-1 flex shadow-sm rounded-md"
                    >
                      <div className="flex-shrink-0 flex items-center justify-center bg-vide-gray w-16 text-white text-sm font-medium rounded-l-md">
                        <img className="h-12 w-12" src={px1Device} alt="" />
                      </div>

                      <div className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                        <div className="flex-1 px-4 py-2 text-sm truncate">
                          <strong className="text-gray-900 font-medium hover:text-gray-600">
                            {device.systemname}
                          </strong>
                          {/* <p className="text-gray-500">{device.deviceStatus}</p> */}
                          <p className="text-gray-500">Linked</p>
                        </div>

                        <div className="flex-shrink-0 pr-2">
                          <button
                            type="button"
                            className="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            <span className="sr-only">Select Device</span>
                            <StatusOnlineIcon
                              className="w-5 h-5"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-12">
              <Link to="/dash/devices" className="btn-secondary">
                Link Devices
              </Link>
            </div>
          </div>
        </div>
        <SidebarAccount />
      </div>
    </div>
  );
};

export { SidebarDesktop };
